module.exports = __webpack_public_path__ + "img/24.235eb30.jpg";